var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 727 811",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M660 189.1c-2.5.5-7.6 2.4-11.5 4.3-8.3 4.2-3.9-.1-218.5 211.5L270.4 562.3l-14.1 13.8-40.8-42.8C151.7 466.3 89.8 403.7 83 399.2a43.5 43.5 0 0 0-29.9-8c-10.3.3-11.1.5-19.4 4.6a50.3 50.3 0 0 0-27.6 33 61.3 61.3 0 0 0 3.1 33.7c3.2 6.2 30.9 37.1 65.7 73C224.1 689.7 224.8 690.3 234 694.8a52.7 52.7 0 0 0 35.1 3.7c11.9-4.1 36.1-26.4 144.4-133.1a51701 51701 0 0 0 274.9-272.7c28-28.4 30.3-31.5 32.7-44.2 3.1-16.3-3.3-36-14.9-46.6-12-11-30-15.9-46.2-12.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMessage);
export default __webpack_public_path__ + "static/media/check-message.4f5d0137aada505b9fbc79e8e28874fe.svg";
export { ForwardRef as ReactComponent };